import React, { useState } from 'react';

import arrowUpRightIcon from '../../components/brand/icon-arrow-up-right.svg';
import { useInView } from '../../hooks/useInView';
import type { CareersRoles } from './types';

export function CareersRolesSection({ data }: { data: CareersRoles }) {
    const [ref, inView] = useInView<HTMLElement>();
    const [activeCategory, setActiveCategory] = useState<string>('all');

    const filteredItems = activeCategory === 'all'
        ? data.items
        : data.items.filter((item) => item.category === activeCategory);

    return (
        <section
            ref={ref}
            className={`careers-roles faves-reveal-group${inView ? ' faves-reveal-group--in' : ''}`}
            id="open-roles"
        >
            <h2 className="careers-roles__heading faves-display faves-reveal">See open roles</h2>

            <div
                className="careers-roles__filters faves-reveal"
                style={{ '--reveal-delay': '120ms' } as React.CSSProperties}
                role="group"
                aria-label="Filter open roles by category"
            >
                {data.categories.map((category) => {
                    const isActive = category === activeCategory;
                    return (
                        <button
                            key={category}
                            type="button"
                            aria-pressed={isActive}
                            className={`careers-roles__filter faves-eyebrow faves-glass${isActive ? ' careers-roles__filter--active' : ''}`}
                            onClick={() => setActiveCategory(category)}
                        >
                            {category}
                        </button>
                    );
                })}
            </div>
            { data.items.length === 0 ? 
                <p>There are no open roles at this time.</p>
                : <ul
                    className="careers-roles__list faves-reveal"
                    style={{ '--reveal-delay': '200ms' } as React.CSSProperties}
                >
                    {filteredItems.map((role) => (
                        <li key={role.id} className="careers-roles__item">
                            <a className="careers-roles__row" href={role.href}>
                                <span className="careers-roles__title faves-h3">{role.title}</span>
                                <span className="careers-roles__meta careers-roles__meta--category faves-eyebrow">{role.category}</span>
                                <span className="careers-roles__meta faves-eyebrow">{role.employmentType}</span>
                                <span className="careers-roles__meta faves-eyebrow">{role.location}</span>
                                <span className="careers-roles__see-role faves-eyebrow">
                                    see role
                                    <img className="careers-roles__see-role-icon" src={arrowUpRightIcon} alt="" aria-hidden="true" />
                                </span>
                            </a>
                        </li>
                    ))}
                </ul>
            }
        </section>
    );
}
